var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-20 lg:mb-[160px]"},[_c('AboutUsOurTotality'),_vm._v(" "),_c('AboutUsFeatures',{staticClass:"mt-[80px] lg:mt-[120px]"}),_vm._v(" "),_c('AboutUsFounders',{staticClass:"mt-[80px] lg:mt-[120px]"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }